import React from 'react';
import { VstButton } from 'vstui';
import HighlightAction from '../../actions/highlight-action';
import FollowerAction from '../../actions/follower-action';

const Follower = ({ follower, blocked }) => {
  const block = () => { FollowerAction.block(follower.id) }
  const unblock = () => { FollowerAction.unblock(follower.id) }

  return (
    <li key={follower.id}>
      <div className="single-follower">
        <div className={ `${blocked ? 'blocked ' : ''}friend-name` }>
          { follower.full_name }
          { blocked && <span className="blocked"> ({ i18n.t("sharing.blocked") })</span> }
        </div>
        <VstButton className="block-follower noButton" onClick={ blocked ? unblock : block }>
          { blocked ? i18n.t("sharing.unblock") : i18n.t("sharing.block") }
        </VstButton>
      </div>
    </li>
  )
};

export default Follower;